import Vue from "vue";
import store from "../store/store.js";
import VueRouter from "vue-router";
// import { Role } from "./_helper";

function lazyLoad(view){
  return() => import(/* webpackChunkName: "[request]" */ `@/views/${view}.vue`)
}
function lazyLoadComponent(view){
  return() => import(/* webpackChunkName: "[request]" */ `@/components/${view}.vue`)
}

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: lazyLoad("Home"),
    meta: { authorize: [] },
  },
  {
    path: "/:account/",
    name: "AccountHome",
    component: lazyLoad("AccountHome"),
    meta: { authorize: [] },
  },
  {
    path: "/:account/form/:formId/:edit?/:newform?",
    name: "Form",
    component: lazyLoad("Form"),
    meta: { authorize: [] },
  },
  {
    path: "/:account/covid-check/:formId/",
    name: "CovidCheck",
    component: lazyLoad("CovidCheck"),
    meta: { authorize: [] },
  },
  {
    path: "/:account/confirmation/:formId?",
    name: "Confirmation",
    component: lazyLoad("Confirmation"),
    meta: { authorize: [] },
  },
  {
    path: "/:account/invoice/:invoiceId?",
    name: "Invoice",
    component: lazyLoad("Invoice"),
    meta: { authorize: [] },
  },
  {
    path: "/invoice/404",
    name: "Invoice404",
    component: lazyLoadComponent("error/Invoice404"),
    meta: { authorize: [] },
  },
  {
    path: "/form/404",
    name: "Form404",
    component: lazyLoadComponent("error/Form404"),
    meta: { authorize: [] },
  },
  {
    path: "/404",
    name: "General404",
    component: lazyLoadComponent("error/General404"),
    meta: { authorize: [] },
  },
  // {
  //   path: "/login",
  //   name: "Login",
  //   component: lazyLoadComponent("auth/Login"),
  //   meta: { authorize: [] },
  // },
  // {
  //   path: "/register",
  //   name: "Register",
  //   component: lazyLoadComponent("auth/Register"),
  //   meta: { authorize: [] },
  // },
  // {
  //   path: "/secure/reset/password",
  //   name: "ResetPassword",
  //   component: lazyLoad("secure/ResetPassword"),
  //   meta: { authorize: [Role.User] },
  // },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  if (
    to.matched.some(
      (record) => record.path.startsWith("/secure/") || record.meta.requiresAuth
    )
  ) {
    if (store.getters.isLoggedIn) {
      next();
      return;
    }
    next("/login");
  } else {
    next();
  }
});

export default router;
